
import { defineComponent, defineAsyncComponent } from "vue";
// const AsyncComponents = () => import('./componets/AsyncComponnets.vue');
const AsyncComponents = defineAsyncComponent(
    () => import("./componets/AsyncComponnets.vue")
);
export default defineComponent({
    name: "App",
    components: {
        AsyncComponents,
    },
    setup() {
        return {
        };
    },
});
